/* @deprecated Copied to app/modules/procurement/pages/vendors_management/vendor-profile/businessDetails/view-bank-details.tsx. This file still serves the existing /UProcure routes. */
/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * @file view-bank-details.tsx
 * @module app/modules/uProcure/vendors_management/vendor-profile/businessDetails/view-bank-details
 * @description Page component for managing view bank details in the vendors management section.
 *   Displays a list of view bank details with pagination, search functionality, and CRUD operations.
 *   Allows users to view the details of view bank details with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Col, Row } from "react-bootstrap";
import {
  BANKTYPES
} from "../../../../../../utils/staticJSON";

const ViewBankDetails = (props: any) => {
  return (
    <>
      <div className="card-body p-5">
        {props.profileData.business.banks &&
          props.profileData.business.banks.length ? (
          // props.profileData.business.banks.map((bank: any, index: number) => (
          props.profileData.business.banks?.map((bank: any, index: number) => (
            <div key={index} className={`${index !== props.profileData.business.banks.length - 1 ? 'border-bottom mb-10 pb-10 ' : ''}`}>
              <Row className="mb-7 mt-7">
                <Col lg={2}>
                  <label className="fs-16 fw-500 text-dark">Bank Name:</label>
                </Col>
                <div className="col-lg-10">
                  <span className="fs-16 fw-600 text-dark">
                    {bank?.bankName || "-"}
                  </span>
                </div>
              </Row>

              <Row className="mb-7">
                <Col lg={2}>
                  <label className="fs-16 fw-500 text-dark">Bank Branch:</label>
                </Col>
                <div className="col-lg-10">
                  <span className="fs-16 fw-600 text-dark">
                    {bank?.branchName || "-"}
                  </span>
                </div>
              </Row>
              <Row className="mb-7">
                <Col lg={2}>
                  <label className="fs-16 fw-500 text-dark">
                    Account Number:
                  </label>
                </Col>
                <div className="col-lg-10">
                  <span className="fs-16 fw-600 text-dark">
                    {bank?.accountNumber || "-"}
                  </span>
                </div>
              </Row>

              {bank?.bankType && (
                <Row className="mb-7">
                  <Col lg={2}>
                    <label className="fs-16 fw-500 text-dark">Mobile wallet:</label>
                  </Col>
                  <div className="col-lg-10">
                    <span className="fs-16 fw-600 text-dark">
                      {bank?.bankType
                        ? BANKTYPES.find((item) => item.value == bank?.bankType)
                          ?.title || ""
                        : ""}
                    </span>
                  </div>
                </Row>
              )}

              {bank.tigoNumber && (
                <Row className="mb-7">
                  <Col lg={2}>
                    <label className="fs-16 fw-500 text-dark">
                      {bank?.bankType
                        ? BANKTYPES.find((item) => item.value == bank?.bankType)
                          ?.title || ""
                        : ""} Number:
                    </label>
                  </Col>
                  <div className="col-lg-10">
                    <span className="fs-16 fw-600 text-dark">
                      {bank?.tigoNumber}
                    </span>
                  </div>
                </Row>
              )}

              <Row className="mb-7">
                <Col lg={2}>
                  <label className="fs-16 fw-500 text-dark">
                    Identifier Code:
                  </label>
                </Col>
                <div className="col-lg-10">
                  <span className="fs-16 fw-600 text-dark">
                    {bank?.identifierCode || ""}
                  </span>
                </div>
              </Row>
            </div>
          ))
        ) : (
          // ))
          <></>
        )}
      </div>
    </>
  );
};

export { ViewBankDetails };

